<template>
    <div
        class="modal fade shipping-kitting-preferences-modal"
        id="shippingKittingPreferencesModal"
        tabindex="-1"
        role="dialog"
        aria-labelledby="shippingKittingPreferencesModalLabel"
        aria-hidden="true"
        data-backdrop="static"
        data-keyboard="false"
    >
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title" id="shippingKittingPreferencesModalLabel">
                        Select Your Shipping & Kitting Preferences
                    </h4>
                    <button
                        type="button"
                        class="close"
                        data-dismiss="modal"
                        aria-label="Close"
                        @click="closeModal"
                    >
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <!-- Question 1: Will this order be shipped to more than one address? -->
                        <div class="preference-question mb-2">
                            <label class="question-label">
                                Will this order be shipped to more than one address?
                            </label>
                            <div class="radio-group mt-2">
                                <label class="radio-label">
                                    <input
                                        type="radio"
                                        name="split_shipment"
                                        value="yes"
                                        v-model="preferences.split_shipment"
                                    />
                                    <span>Yes</span>
                                </label>
                                <label class="radio-label">
                                    <input
                                        type="radio"
                                        name="split_shipment"
                                        value="no"
                                        v-model="preferences.split_shipment"
                                    />
                                    <span>No</span>
                                </label>
                            </div>
                        </div>
                </div>
                <div class="modal-footer">
                    <!-- <button
                        type="button"
                        class="btn btn-secondary cancel-btn"
                        data-dismiss="modal"
                        @click="closeModal"
                    >
                        Cancel
                    </button> -->
                    <button
                        type="button"
                        class="btn btn-primary bg_primary_orange text_white continue-btn"
                        @click="handleSubmit"
                    >
                        CONTINUE
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ShippingKittingPreferencesModal",
    data() {
        return {
            preferences: {
                split_shipment: "no"
            }
        };
    },
    methods: {
        openModal() {
            /* eslint-disable */
            // Use jQuery directly if available for faster execution
            if (typeof window.$ !== 'undefined') {
                const $modal = window.$("#shippingKittingPreferencesModal");
                // Ensure modal is initialized before showing
                if ($modal.length && !$modal.data('bs.modal')) {
                    $modal.modal({
                        backdrop: 'static',
                        keyboard: false,
                        show: false
                    });
                }
                $modal.modal("show");
            } else {
                this.$nextTick(() => {
                    $("#shippingKittingPreferencesModal").modal("show");
                });
            }
            /* eslint-enable */
        },
        closeModal() {
            this.resetPreferences();
            /* eslint-disable */
            $("#shippingKittingPreferencesModal").modal("hide");
            /* eslint-enable */
        },
        resetPreferences() {
            this.preferences = {
                split_shipment: "no"
            };
        },
        handleSubmit(event) {
            if (event) {
                event.preventDefault();
                event.stopPropagation();
            }
            
            console.log("handleSubmit called - Button clicked");
            console.log("Current preferences:", this.preferences);
            
            const preferences = {
                split_shipment: this.preferences.split_shipment === "yes"
            };

            console.log("Processed preferences:", preferences);

            // Store preferences in Vuex first
            try {
                if (preferences.split_shipment) {
                    this.$store.commit('splitShipment/setSplitShipment', true);
                    console.log("Split shipment set to true in Vuex");
                } else {
                    this.$store.commit('splitShipment/setSplitShipment', false);
                }
            } catch (error) {
                console.error("Vuex commit error:", error);
            }

            // Emit event with preferences
            this.$emit("preferences-saved", preferences);

            // Navigate to checkout for both split and standard flows
            const isSplitShipment = preferences.split_shipment;
            const self = this;
            /* eslint-disable */
            const $modal = window.$("#shippingKittingPreferencesModal");
            if ($modal && $modal.length) {
                // After modal fully closes, navigate to checkout
                $modal.one("hidden.bs.modal", function() {
                    self.$nextTick(() => {
                        if (self.$router) {
                            self.$router.push({ path: "/checkout/v3" }).then(() => {
                                console.log(isSplitShipment ? "Navigation to split shipment checkout successful" : "Navigation to standard checkout successful");
                            }).catch(err => {
                                console.error('Navigation error:', err);
                                // Fallback to window.location
                                window.location.href = "/checkout/v3";
                            });
                        } else {
                            console.error("Router not available, using window.location");
                            window.location.href = "/checkout/v3";
                        }
                    });
                });
                // Close the modal
                $modal.modal("hide");
            } else {
                // Fallback if modal not found - navigate directly
                this.$nextTick(() => {
                    if (this.$router) {
                        this.$router.push({ path: "/checkout/v3" });
                    } else {
                        window.location.href = "/checkout/v3";
                    }
                });
            }
            /* eslint-enable */
        }
    },
    mounted() {
        // Pre-initialize modal immediately for faster opening
        /* eslint-disable */
        const initModal = () => {
            if (typeof window.$ !== 'undefined') {
                const $modal = window.$("#shippingKittingPreferencesModal");
                if ($modal.length) {
                    // Initialize modal immediately without showing
                    $modal.modal({
                        backdrop: 'static',
                        keyboard: false,
                        show: false
                    });
                    
                    // Set up event listener for when modal is hidden
                    $modal.off("hidden.bs.modal").on("hidden.bs.modal", () => {
                        this.resetPreferences();
                    });
                }
            }
        };
        
        // Try to initialize immediately
        initModal();
        
        // Also try after nextTick in case DOM isn't ready
        this.$nextTick(() => {
            initModal();
        });
        /* eslint-enable */
    }
};
</script>

<style scoped>



.shipping-kitting-preferences-modal .modal-content .radio-group {
    display: flex;
    gap: 30px;
}

.shipping-kitting-preferences-modal .modal-content .radio-label {
    display: flex;
    align-items: center;
    cursor: pointer;
    font-size: 15px;
    color: #555;
}



.shipping-kitting-preferences-modal .modal-footer {
    border-top: 1px solid #e0e0e0;
    padding: 32px 0px 0px 20px;
    display: flex;
    justify-content: flex-end;
    gap: 10px;
}

.shipping-kitting-preferences-modal .modal-footer .btn {
    min-width: 100px;
    padding: 10px 20px;
    display: block !important;
    visibility: visible !important;
    opacity: 1 !important;
}

.cancel-btn {
    background-color: transparent !important;
    color: #1D6CB5 !important;
    border-color: #1D6CB5 !important;
    font-weight: 600;
    height: 48px;
}

.bg_primary_orange {
    background-color: #F2790C;
}

.text_white {
    color: #ffffff;
}

.continue-btn {
    min-width: 140px;
    height: 48px;
    padding: 0 24px;
    border-radius: 0px;
    font-weight: 600;
    font-size: 16px;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    border: none;
    box-shadow: none;
    display: inline-flex;
    align-items: center;
    justify-content: center;
}


/* Non-scoped styles to override global CSS */
#shippingKittingPreferencesModal {
    transition: opacity 0.05s linear !important;
}

#shippingKittingPreferencesModal.fade .modal-dialog {
    transition: transform 0.05s ease-out !important;
}

#shippingKittingPreferencesModal .radio-label input[type="radio"] {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    width: 20px;
    height: 20px;
    margin-right: 8px;
    border-radius: 50%;
    border: 2px solid #1D6CB5;
    background-color: #ffffff;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    position: relative;
    box-sizing: border-box;
    left: 0px;
}

#shippingKittingPreferencesModal .radio-label input[type="radio"]::before {
    content: "";
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: #1D6CB5;
    transform: scale(0);
    transition: transform 0.15s ease-in-out;
}

#shippingKittingPreferencesModal .radio-label input[type="radio"]:checked::before {
    transform: scale(1);
}

#shippingKittingPreferencesModal .modal-footer .btn {
    display: block !important;
    visibility: visible !important;
    opacity: 1 !important;
}

#shippingKittingPreferencesModal .cancel-btn {
    background-color: transparent !important;
    color: #6c757d !important;
    border-color: #6c757d !important;
}
.shipping-kitting-preferences-modal .modal-content{
    padding: 32px;
}
.shipping-kitting-preferences-modal .modal-content .modal-header{
    padding: 0px 0px 12px 0px;
}
.shipping-kitting-preferences-modal .modal-content .modal-header .close span{
        font-size: 30px;
}
.shipping-kitting-preferences-modal .modal-dialog{
    max-width: 765px;
}
.shipping-kitting-preferences-modal .modal-content .modal-body{
    padding: 15px 0px;
}
.shipping-kitting-preferences-modal .modal-content .preference-question {
    padding: 15px 0;
    border-bottom: 1px solid #B6B6B666;
}

.shipping-kitting-preferences-modal .modal-content .preference-question:last-child {
    border-bottom: none;
    padding-bottom: 0px;
}
.shipping-kitting-preferences-modal .modal-content .question-label{
       font-weight: 500;
    font-size: 16px;
    color: #121212;
    line-height: 16px;
    display: block;
    margin-bottom: 10px;
}
.shipping-kitting-preferences-modal .modal-content .radio-label span{
 font-weight: 600;
    font-size: 16px;
    color: #121212;
    line-height: 16px;
}
.shipping-kitting-preferences-modal .modal-title{
    color: #121212;
    font-weight: 600;
    font-size: 20px;
    line-height: 20px;
}
</style>


